import { render, staticRenderFns } from "./BoxCheckoutSummary.component.vue?vue&type=template&id=ca044760"
import script from "./BoxCheckoutSummary.component.vue?vue&type=script&lang=js"
export * from "./BoxCheckoutSummary.component.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports